module.exports = __webpack_public_path__ + "img/[福].22f8e02d.svg";